"use client";
/* eslint-disable @typescript-eslint/no-unused-vars -- TODO(lint-cleanup): remove disables and fix violations in a follow-up PR */

import { useRouter } from "next/navigation";
import { ReactNode } from "react";
import BackButton from "@/components/BackButton";
type AppHeaderProps = {
  title: string;
  subtitle?: string | ReactNode;
  subtitle2?: string | ReactNode;
  showBackButton?: boolean; // Option to show back button
};

export default function AppHeader({
  title,
  subtitle,
  subtitle2,
  showBackButton = false,
}: AppHeaderProps) {
  const router = useRouter();

  return (
    <header
      className={`
        w-full  text-on-surface
        rounded-b-3xl
        px-6
        flex flex-col items-center relative
        transition-all
        ${showBackButton ? "py-2" : "py-6"}
      `}
    >
      {/* Title & Subtitles */}
      <div className="flex flex-col items-center">
        <h1 className="text-2xl font-bold text-center">{title}</h1>

        {subtitle && <p className="mt-1 text-base opacity-90 text-center">{subtitle}</p>}

        {subtitle2 && <p className="mt-3 text-base opacity-80 text-center">{subtitle2}</p>}
      </div>
    </header>
  );
}
